/**
 * FIX: Quick-buy drawer/popover queda "atrapado" dentro de la grilla en páginas
 * de colección, en vez de cubrir toda la pantalla (como sí hace en Home/PDP).
 *
 * Causa: algún ancestro de <quick-buy-drawer>/<quick-buy-popover> en la página
 * de colección tiene una propiedad CSS (transform, filter, perspective, contain,
 * will-change, etc.) distinta de 'none' que crea un "containing block" nuevo.
 * Esto hace que el drawer, aunque sea position:fixed, se posicione relativo a
 * ese ancestro en vez de al viewport real de la ventana.
 *
 * Solución: mover (hacer "portal") los elementos <quick-buy-drawer> y
 * <quick-buy-popover> directo a <body>, tanto al cargar la página como cada
 * vez que el scroll infinito inyecte productos nuevos. Al colgar de <body>,
 * quedan fuera de cualquier ancestro problemático y su position:fixed vuelve
 * a ser relativo al viewport real.
 *
 * Cómo probar en staging:
 * 1. Agregar este archivo como asset del tema (ej: quick-buy-overlay-fix.js)
 * 2. Cargarlo en theme.liquid, después de custom.js:
 *      <script src="{{ 'quick-buy-overlay-fix.js' | asset_url }}" defer></script>
 * 3. Probar en una colección: clic en primera fila, última fila, y después
 *    de que el scroll infinito cargue más productos. El drawer/popover debe
 *    verse igual que en Home/PDP: pantalla completa, tapando header y footer.
 */
(function () {
  function relocateQuickBuyOverlays(root) {
    root = root || document;
    var overlays = root.querySelectorAll('quick-buy-drawer, quick-buy-popover');
    overlays.forEach(function (el) {
      if (el.parentElement !== document.body) {
        document.body.appendChild(el);
      }
    });
  }

  function init() {
    // Relocar todo lo que ya existe al cargar la página
    relocateQuickBuyOverlays();

    // Relocar lo que se inyecte después: scroll infinito, filtros, Y navegación
    // instantánea entre páginas de colección (Focal usa 'data-instant-allow-query-string'
    // en <body>, lo que indica que la paginación reemplaza contenedores completos vía AJAX
    // en vez de solo modificar su contenido interno). Por eso observamos document.body
    // completo en vez de un contenedor específico — así no importa qué nodo sea
    // reemplazado entero, siempre lo detectamos. Es el mismo patrón que usa el propio
    // script nativo de Focal para 'data-recovery-loading' en theme.liquid.
    var observer = new MutationObserver(function (mutations) {
      var hasNewNodes = mutations.some(function (m) {
        return m.addedNodes && m.addedNodes.length > 0;
      });
      if (hasNewNodes) {
        relocateQuickBuyOverlays();
      }
    });

    observer.observe(document.body, { childList: true, subtree: true });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init, { once: true });
  } else {
    init();
  }
})();